export default "<div class=\"pdfEditorWidget\">\n    <div data-dojo-attach-point=\"pdfContainer\" class=\"w3-hide\"></div>\n</div>\n"